import { Modal } from "antd";
import Table, { ColumnsType } from "antd/lib/table";
import moment from "moment";
import { Link } from "react-router-dom";
import { mConstants } from "../../../../helper/constants";
import { dialog } from "../../../../helper/dialog";
import { DocumentCategory, DocumentUI } from "../entity/document.model";
import { documentService } from "../service/document.service";
import CustomImage from "../../../../component/CustomImage";

export interface DocumentTableProps {
  documents: DocumentUI[];
}

function DocumentTable(props: DocumentTableProps) {
  const documentTableColumns: ColumnsType<DocumentUI> = [
    {
      title: "Д/д",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Үндсэн зураг",
      dataIndex: "mainImagePath",
      key: "mainImagePath",
      render: (mainImagePath: string | null) => {
        if (!mainImagePath) return null;

        const imageUrl =
            mConstants.API_URL + mConstants.PUBLIC_FILE_DOWNLOAD_PATH + mainImagePath;

        return (
            <CustomImage
                alt={imageUrl}
                src={imageUrl}
            />
        );
      },
    },
    {
      title: "Гарчиг",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Үүсгэсэн огноо",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (createdDate: string) =>
        moment(createdDate).format(mConstants.DATE_FORMAT),
    },
    {
      title: "Үүсгэсэн хүн",
      dataIndex: "username",
      key: "username",
    },
    {
      title: "Ангилал",
      dataIndex: "documentCategory",
      key: "documentCategory",
      render: (value: DocumentCategory) => value.name,
    },
    {
      title: "Үйлдэл",
      align: "center",
      dataIndex: "actions",
      key: "actions",
      render: (_: any, record: DocumentUI) => (
        <div className="list-icons">
          <div className="dropdown">
            <a href="#" className="list-icons-item" data-toggle="dropdown">
              <i className="icon-menu9"></i>
            </a>

            <div className="dropdown-menu dropdown-menu-right">
              <Link
                to={`/documents/${record.uuid}`}
                key={`edit-${record.uuid}`}
                className="dropdown-item"
              >
                <i className="icon-pencil3"></i>
                Дэлгэрэнгүй
              </Link>
              <a
                href="#"
                key={`delete-${record.uuid}`}
                className="dropdown-item"
                onClick={() => {
                  Modal.confirm({
                    title: "Баталгаажуулах",
                    content: "Та устгахдаа итгэлтэй байна уу?",
                    okText: "Үргэлжлүүлэх",
                    cancelText: "Хаах",
                    onOk: () => {
                      documentService.deleteDocument(record.uuid).then((x) => {
                        dialog.success("Документ амжилттай устгалаа.");
                      });
                    },
                  });
                }}
              >
                <i className="icon-bin2"></i>
                Устгах
              </a>
            </div>
          </div>
        </div>
      ),
    },
  ];

  return (
    <Table
      className="table table-responsive"
      columns={documentTableColumns}
      dataSource={props.documents.map((x, index) => {
        x.index = index + 1;
        return x;
      })}
      pagination={false}
    />
  );
}

export default DocumentTable;
